<template>
  <div class="fullHeight">
    <vue-custom-scrollbar
      class="scroll-area"
      :settings="settings"
      @ps-scroll-y="scrollHanle"
      id="TackingInfoContainer"
      v-chat-scroll
      @scroll-end="loadNewData"
    >
      <b-card no-body>
        <b-tabs card v-model="tabIndex">
          <b-tab title="客戶明細" active v-if="careTypes.Client">
            <b-list-group flush>
              <b-list-group-item
                v-for="(detail,index) in CustomerTackingDetails"
                style="padding-left: 0px; padding-right: 0px;"
                :key="index"
              >
                <b-container>
                  <b-row>
                    <b-col cols="7" style="padding-right: 0px;">
                      <div v-html="detail.TackingDetail"></div>
                    </b-col>
                    <b-col cols="5" style="text-align: right;">{{detail.TackingDate}}</b-col>
                  </b-row>
                  <b-row v-show="detail.showFollowUp && operatorIsMainContact">
                    <b-col>
                      <b-button
                        block
                        pill
                        variant="outline-danger"
                        style="font-size: 15px;"
                        @click="followUp(detail.careSn)"
                      >Follow UP</b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab title="業務追蹤" v-if="careTypes.Lead">
            <b-list-group flush>
              <b-list-group-item
                v-for="(detail,index) in leadTackingDetails"
                style="padding-left: 0px; padding-right: 0px;"
                :key="index"
              >
                <b-container>
                  <b-row>
                    <b-col cols="7" style="padding-right: 0px;">
                      <div v-html="detail.TackingDetail"></div>
                    </b-col>
                    <b-col cols="5" style="text-align: right;">{{detail.TackingDate}}</b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab title="社群追蹤" v-if="careTypes.SocialLead">
            <b-list-group flush>
              <b-list-group-item
                v-for="(detail,index) in socialLeadTackingDetails"
                style="padding-left: 0px; padding-right: 0px;"
                :key="index"
              >
                <b-container>
                  <b-row>
                    <b-col cols="7" style="padding-right: 0px;">
                      <div v-html="detail.TackingDetail"></div>
                    </b-col>
                    <b-col cols="5" style="text-align: right;">{{detail.TackingDate}}</b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
            </b-list-group>
          </b-tab>
        </b-tabs>
      </b-card>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import http from "../../http.js";
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import qs from "qs";
import store_tackingLead from "@/vuex/store_tackingLead.js";
export default {
  props: ["leadSn", "socialLeadId", "tutorChatToken"],
  data() {
    return {
      tabIndex: 1,
      careTypes: { Client: false, Lead: false, SocialLead: false },
      customerTackingDetails: [],
      leadTackingDetails: [],
      socialLeadTackingDetails: [],
      customerTackingDetailsIndex: 0,
      leadTackingDetailsIndex: 0,
      socialLeadTackingDetailsIndex: 0,
      customerTackingDetailsIsEnd: false,
      leadTackingDetailsIsEnd: false,
      socialLeadTackingDetailsIsEnd: false,
      settings: {
        maxScrollbarLength: 60
      }
    };
  },
  created() {
    //在電腦版SCRM首頁剛載入時不會帶入兩個參數。
    if (this.leadSn === undefined && this.socialLeadId === undefined) {
      return;
    }
    //缺少 tutorChatToken（例如連結未帶 tct 或登入 ticket 已失效）時不發送請求，
    //避免後端解 token 失敗產生大量錯誤。
    if (!this.tutorChatToken) {
      return;
    }
    http
      .post(
        "/SCRMApp/GetCareTypes",
        qs.stringify({
          SocialLeadId: this.socialLeadId,
          LeadSn: this.leadSn,
          tutorChatToken: this.tutorChatToken
        })
      )
      .then(response => {
        this.careTypes = response.data.Result;
        if (this.careTypes.Client) {
          this.getTackingDetails(0, this.customerTackingDetailsIndex);
        }
        if (this.careTypes.Lead) {
          this.getTackingDetails(1, this.leadTackingDetailsIndex);
        }
        if (this.careTypes.SocialLead) {
          this.getTackingDetails(2, this.socialLeadTackingDetailsIndex);
        }
      })
      .catch(function(error) {
        alert(error);
        window.location.href = "/#/Error";
      });
  },
  methods: {
    getTackingDetails: async function(careType, startIndex) {
      await http
        .post(
          "/SCRMApp/GetTackingDetails",
          qs.stringify({
            SocialLeadId: this.socialLeadId,
            LeadSn: this.leadSn,
            CareType: careType,
            StartIndex: startIndex,
            tutorChatToken: this.tutorChatToken
          })
        )
        .then(response => {
          let resultIsEnd = response.data.Result.length == 0;
          switch (careType) {
            case 0:
              if (resultIsEnd) {
                this.customerTackingDetailsIsEnd = true;
                return;
              }
              this.customerTackingDetails.push.apply(
                this.customerTackingDetails,
                response.data.Result
              );
              break;
            case 1:
              if (resultIsEnd) {
                this.leadTackingDetailsIsEnd = true;
                return;
              }
              this.leadTackingDetails.push.apply(
                this.leadTackingDetails,
                response.data.Result
              );
              break;
            case 2:
              if (resultIsEnd) {
                this.socialLeadTackingDetailsIsEnd = true;
                return;
              }
              this.socialLeadTackingDetails.push.apply(
                this.socialLeadTackingDetails,
                response.data.Result
              );
              break;
          }
        })
        .catch(function(error) {
          alert(error);
          window.location.href = "/#/Error";
        });
    },
    loadMoreClientTackingDetails: function() {
      if (!this.customerTackingDetailsIsEnd) {
        this.customerTackingDetailsIndex =
          this.customerTackingDetailsIndex + 10;
        this.getTackingDetails(0, this.customerTackingDetailsIndex);
      }
    },
    loadMoreLeadTackingDetails: function() {
      if (!this.leadTackingDetailsIsEnd) {
        this.leadTackingDetailsIndex = this.leadTackingDetailsIndex + 10;
        this.getTackingDetails(1, this.leadTackingDetailsIndex);
      }
    },
    loadMoreSocialLeadTackingDetails: function() {
      if (!this.socialLeadTackingDetailsIsEnd) {
        this.socialLeadTackingDetailsIndex =
          this.socialLeadTackingDetailsIndex + 10;
        this.getTackingDetails(2, this.socialLeadTackingDetailsIndex);
      }
    },
    //todo 這裡只能取到tab的index，無法知道現在index是哪一種名單，只能暫時用笨方法解掉。
    loadNewData: function() {
      if (
        this.careTypes.Client &&
        this.careTypes.Lead &&
        this.careTypes.SocialLead
      ) {
        switch (this.tabIndex) {
          case 0:
            this.loadMoreClientTackingDetails();
            break;
          case 1:
            this.loadMoreLeadTackingDetails();
            break;
          case 2:
            this.loadMoreSocialLeadTackingDetails();
            break;
        }
        return;
      }
      if (this.careTypes.Lead && this.careTypes.SocialLead) {
        switch (this.tabIndex) {
          case 0:
            this.loadMoreLeadTackingDetails();
            break;
          case 1:
            this.loadMoreSocialLeadTackingDetails();
            break;
        }
        return;
      }
      if (this.careTypes.Client) {
        this.loadMoreClientTackingDetails();
        return;
      }
      if (this.careTypes.Lead) {
        this.loadMoreLeadTackingDetails();
        return;
      }
      if (this.careTypes.SocialLead) {
        this.loadMoreSocialLeadTackingDetails();
        return;
      }
    },
    scrollHanle(evt) {},
    followUp: function(careSn) {
      store_tackingLead.dispatch("setCareSn", careSn);
    }
  },
  computed: {
    CustomerTackingDetails: function() {
      return this.customerTackingDetails;
    },
    operatorIsMainContact(){
      return store_tackingLead.state.operatorIsMainContact;
    },
  }
};
</script>

<style>
#TackingInfoContainer {
  height: 100%;
  overflow: auto;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 15px 15px 60px 15px;
}

#TackingInfoContainer .card-header {
  background: none !important;
  border: none;
  padding: 0.75rem 0.6rem 2em;
}

#TackingInfoContainer .card {
  border: none;
}

#TackingInfoContainer .card-body {
  padding: 0;
}

#TackingInfoContainer .card-header .nav-tabs .nav-link {
  border-radius: 50px;
  color: #444;
  font-size: 15px;
  padding: 0.6rem 1rem;
}

#TackingInfoContainer .card-header .nav-tabs .nav-link.active {
  background: #b20404;
  color: #fff;
}

#TackingInfoContainer .nav-tabs .nav-link {
  border: none;
}
#TackingInfoContainer .nav-tabs .nav-item {
  margin-bottom: 0;
  text-align: center;
}

#TackingInfoContainer .list-group-flush .list-group-item {
  background: #f1f1f1;
  color: #929292;
  border: none;
  border-radius: 5px;
  margin: 7px 0;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 100%;
}

@media (max-width: 340px) {
  #TackingInfoContainer .card-header .nav-tabs .nav-link {
    font-size: 14px;
    padding: 0.6rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Main/TackingLeadInfoList.vue